var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#25262F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.528 23.029C35.333 24.4 36.499 26.568 36.499 29.006C36.499 30.449 36.09 31.797 35.383 32.941C35.383 32.941 35.826 34.473 36.124 35.503C36.175 35.681 36.124 35.873 35.99 36.002C35.856 36.131 35.662 36.175 35.486 36.116C34.501 35.788 33.062 35.31 33.062 35.31C31.891 36.067 30.496 36.506 28.999 36.506C26.552 36.506 24.378 35.332 23.008 33.517C28.41 32.692 32.687 28.426 33.528 23.029ZM21.157 11.494C26.418 11.528 30.679 15.809 30.679 21.078C30.679 26.347 26.418 30.628 21.157 30.662H21.095C19.329 30.662 17.674 30.183 16.252 29.348L16.184 29.308C16.184 29.308 13.777 30.004 12.414 30.398C12.375 30.409 12.336 30.415 12.296 30.417H12.279C12.144 30.418 12.011 30.364 11.915 30.264C11.786 30.13 11.742 29.936 11.801 29.76C12.236 28.453 12.989 26.19 12.989 26.19C12.053 24.71 11.511 22.957 11.511 21.078C11.511 15.788 15.806 11.494 21.095 11.494H21.157Z",
    fill: "#E7E7E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon_support.08776c21bd4df7e42939ed0a116b1a46.svg";
export { ForwardRef as ReactComponent };